import script from "./ArgonInputPhone.vue?vue&type=script&setup=true&lang=js"
export * from "./ArgonInputPhone.vue?vue&type=script&setup=true&lang=js"

import "./ArgonInputPhone.vue?vue&type=style&index=0&id=595aa1dd&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-595aa1dd"]])

export default __exports__